module.exports = __webpack_public_path__ + "static/media/02.75e3da78.png";